<div class="row" style="--bs-gutter-x: 0">
  <div class="col-md-2"></div>
  <div class="col-sm-12 col-md-8">
    <ng-container *ngIf="languageService.selectedLanguage === 'en'; else termsNotEn">
      <h2>Terms of Service – {{config.contact_current_product}}</h2>
      Last updated: 23 July 2026.<br>
      <br>

      <b>1. General provisions</b><br>
      These Terms of Service define the rules for using the {{config.contact_current_product}} website and for the provision of IT services by the Service Provider.<br>
      Service Provider:<br>
      <b>{{config.contact_company_name}}</b><br>
      {{config.contact_company_adress_line_0}}, {{config.contact_company_adress_line_2}}, {{config.contact_company_adress_country}}<br>
      VAT ID: {{config.contact_company_vat}}<br>
      e-mail: {{config.contact_email}}, phone: {{config.contact_phone}}.<br>

      <br>
      <b>2. Scope of services</b><br>
      The Service Provider offers professional IT services, including custom software development, Big Data solutions, data warehousing, system and database optimization, IT security, and high availability (HA) solutions.<br>
      The website is informational in nature and presents the Service Provider's offer. Using the website does not require creating a user account.<br>

      <br>
      <b>3. Terms of cooperation</b><br>
      Services are provided on the basis of individual agreements or offers agreed with the client, which define the scope, schedule, and remuneration.<br>
      The content published on the website does not constitute an offer within the meaning of the Civil Code.<br>

      <br>
      <b>4. Remuneration and payments</b><br>
      Remuneration for services and payment terms are determined individually in the agreement or offer accepted by the client.<br>

      <br>
      <b>5. Liability</b><br>
      The Service Provider performs services with due diligence and in accordance with professional standards.<br>
      The Service Provider is not liable for damages resulting from force majeure or from incorrect data or materials provided by the client. Detailed liability rules are set out in the individual agreement.<br>

      <br>
      <b>6. Intellectual property</b><br>
      The transfer of rights to the results of the work is governed by the individual agreement. The content, graphics, and trademarks published on the website are protected by law and may not be used without the Service Provider's consent.<br>

      <br>
      <b>7. Personal data protection</b><br>
      The rules for processing personal data are described in the <a routerLink="/polityka">Privacy Policy</a> and in the <a routerLink="/rodo">GDPR</a> information clause.<br>

      <br>
      <b>8. Complaints</b><br>
      Complaints regarding services may be submitted by e-mail to {{config.contact_email}}. The Service Provider will consider a complaint within 14 days of its receipt.<br>

      <br>
      <b>9. Final provisions</b><br>
      These Terms are governed by Polish law. The Service Provider reserves the right to amend the Terms; the current version is always published on this page. In matters not regulated herein, the provisions of generally applicable law shall apply.<br>
      <br>
    </ng-container>

    <ng-template #termsNotEn>
    <ng-container *ngIf="languageService.selectedLanguage === 'de'; else termsPl">
      <h2>Nutzungsbedingungen – {{config.contact_current_product}}</h2>
      Zuletzt aktualisiert: 23. Juli 2026.<br>
      <br>

      <b>1. Allgemeine Bestimmungen</b><br>
      Diese Nutzungsbedingungen legen die Regeln für die Nutzung der Website {{config.contact_current_product}} und für die Erbringung von IT-Dienstleistungen durch den Dienstleister fest.<br>
      Dienstleister:<br>
      <b>{{config.contact_company_name}}</b><br>
      {{config.contact_company_adress_line_0}}, {{config.contact_company_adress_line_2}}, {{config.contact_company_adress_country}}<br>
      USt-IdNr.: {{config.contact_company_vat}}<br>
      E-Mail: {{config.contact_email}}, Telefon: {{config.contact_phone}}.<br>

      <br>
      <b>2. Leistungsumfang</b><br>
      Der Dienstleister bietet professionelle IT-Dienstleistungen an, darunter individuelle Softwareentwicklung, Big-Data-Lösungen, Data Warehousing, System- und Datenbankoptimierung, IT-Sicherheit und Hochverfügbarkeitslösungen (HA).<br>
      Die Website hat informativen Charakter und stellt das Angebot des Dienstleisters dar. Die Nutzung der Website erfordert keine Erstellung eines Benutzerkontos.<br>

      <br>
      <b>3. Bedingungen der Zusammenarbeit</b><br>
      Die Leistungen werden auf Grundlage individueller, mit dem Kunden vereinbarter Verträge oder Angebote erbracht, die Umfang, Zeitplan und Vergütung festlegen.<br>
      Die auf der Website veröffentlichten Inhalte stellen kein Angebot im Sinne des Zivilgesetzbuches dar.<br>

      <br>
      <b>4. Vergütung und Zahlungen</b><br>
      Die Vergütung für Leistungen und die Zahlungsbedingungen werden individuell im vom Kunden akzeptierten Vertrag oder Angebot festgelegt.<br>

      <br>
      <b>5. Haftung</b><br>
      Der Dienstleister erbringt die Leistungen mit der gebotenen Sorgfalt und gemäß den beruflichen Standards.<br>
      Der Dienstleister haftet nicht für Schäden, die durch höhere Gewalt oder durch vom Kunden bereitgestellte fehlerhafte Daten oder Materialien entstehen. Detaillierte Haftungsregeln werden im individuellen Vertrag festgelegt.<br>

      <br>
      <b>6. Geistiges Eigentum</b><br>
      Die Übertragung der Rechte an den Arbeitsergebnissen wird im individuellen Vertrag geregelt. Die auf der Website veröffentlichten Inhalte, Grafiken und Marken sind gesetzlich geschützt und dürfen nicht ohne Zustimmung des Dienstleisters verwendet werden.<br>

      <br>
      <b>7. Schutz personenbezogener Daten</b><br>
      Die Regeln für die Verarbeitung personenbezogener Daten sind in der <a routerLink="/polityka">Datenschutzerklärung</a> und in der Informationsklausel <a routerLink="/rodo">DSGVO</a> beschrieben.<br>

      <br>
      <b>8. Beschwerden</b><br>
      Beschwerden zu den Leistungen können per E-Mail an {{config.contact_email}} gerichtet werden. Der Dienstleister bearbeitet eine Beschwerde innerhalb von 14 Tagen nach Eingang.<br>

      <br>
      <b>9. Schlussbestimmungen</b><br>
      Diese Nutzungsbedingungen unterliegen polnischem Recht. Der Dienstleister behält sich das Recht vor, die Bedingungen zu ändern; die aktuelle Version wird stets auf dieser Seite veröffentlicht. In nicht geregelten Angelegenheiten gelten die Bestimmungen des allgemein geltenden Rechts.<br>
      <br>
    </ng-container>

    <ng-template #termsPl>
      <h2>Regulamin świadczenia usług – {{config.contact_current_product}}</h2>
      Ostatnia aktualizacja: 23 lipca 2026 r.<br>
      <br>

      <b>1. Postanowienia ogólne</b><br>
      Niniejszy Regulamin określa zasady korzystania z serwisu {{config.contact_current_product}} oraz świadczenia usług informatycznych przez Usługodawcę.<br>
      Usługodawca:<br>
      <b>{{config.contact_company_name}}</b><br>
      {{config.contact_company_adress_line_0}}, {{config.contact_company_adress_line_2}}, {{config.contact_company_adress_country}}<br>
      NIP: {{config.contact_company_vat}}<br>
      e-mail: {{config.contact_email}}, tel.: {{config.contact_phone}}.<br>

      <br>
      <b>2. Zakres usług</b><br>
      Usługodawca świadczy profesjonalne usługi informatyczne, w tym: tworzenie oprogramowania na zamówienie, rozwiązania Big Data, hurtownie danych, optymalizację systemów i baz danych, bezpieczeństwo IT oraz rozwiązania wysokiej dostępności (HA).<br>
      Serwis ma charakter informacyjny i prezentuje ofertę Usługodawcy. Korzystanie z serwisu nie wymaga zakładania konta.<br>

      <br>
      <b>3. Zasady współpracy</b><br>
      Usługi realizowane są na podstawie indywidualnych umów lub ofert uzgodnionych z klientem, które określają zakres, harmonogram oraz wynagrodzenie.<br>
      Treści prezentowane w serwisie nie stanowią oferty w rozumieniu Kodeksu cywilnego.<br>

      <br>
      <b>4. Wynagrodzenie i płatności</b><br>
      Wynagrodzenie za usługi oraz warunki płatności ustalane są indywidualnie w umowie lub ofercie zaakceptowanej przez klienta.<br>

      <br>
      <b>5. Odpowiedzialność</b><br>
      Usługodawca świadczy usługi z należytą starannością, zgodnie ze standardami zawodowymi.<br>
      Usługodawca nie ponosi odpowiedzialności za szkody wynikłe z działania siły wyższej ani z nieprawidłowych danych lub materiałów przekazanych przez klienta. Szczegółowe zasady odpowiedzialności określa indywidualna umowa.<br>

      <br>
      <b>6. Własność intelektualna</b><br>
      Przeniesienie praw do rezultatów prac regulowane jest w indywidualnej umowie. Treści, grafiki i znaki towarowe opublikowane w serwisie są chronione prawem i nie mogą być wykorzystywane bez zgody Usługodawcy.<br>

      <br>
      <b>7. Ochrona danych osobowych</b><br>
      Zasady przetwarzania danych osobowych opisano w <a routerLink="/polityka">Polityce prywatności</a> oraz w klauzuli informacyjnej <a routerLink="/rodo">RODO</a>.<br>

      <br>
      <b>8. Reklamacje</b><br>
      Reklamacje dotyczące usług można składać na adres e-mail {{config.contact_email}}. Usługodawca rozpatrzy reklamację w terminie 14 dni od jej otrzymania.<br>

      <br>
      <b>9. Postanowienia końcowe</b><br>
      W sprawach nieuregulowanych stosuje się przepisy prawa polskiego. Usługodawca zastrzega sobie prawo do zmiany Regulaminu; aktualna wersja jest zawsze publikowana na tej stronie.<br>
      <br>
    </ng-template>
    </ng-template>

  </div>
  <div class="col-md-2"></div>
</div>
